import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../../app/appTypes"
import { getWithAuth, putWithAuth } from "../../../http"
import {
    DocumentContentActions,
    DocumentStatus,
} from "../../documents/documentsApi"

export type SubjectType =
    | "AUTHOR"
    | "EDITOR"
    | "ADMIN"
    | "CURRENT_STAGE_MEMBER"
    | "COMPANY_USER"
    | "TEAM_MEMBER"

export interface SysDocumentContentActionRule {
    id: number
    companyId: number | null
    documentStatus: string
    subjectType: SubjectType
    actionCode: DocumentContentActions
}

export interface UpsertSysDocumentContentActionRuleDto {
    documentStatus: DocumentStatus
    subjectType: SubjectType
    actionCode: DocumentContentActions
}

export const loadDocumentContentActionRules = createAsyncThunk<
    SysDocumentContentActionRule[],
    void,
    AppThunkAPIType
>(
    "system-document-content-action-rules/load",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            getWithAuth({ url: "api/sys/document-content-action-rules" })
        )
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as SysDocumentContentActionRule[]
        }

        return rejectWithValue(payload ?? { kind: "unknown" })
    }
)

export const upsertSysDocumentContentActionRule = createAsyncThunk<
    void,
    { dto: UpsertSysDocumentContentActionRuleDto; enabled: boolean },
    AppThunkAPIType
>(
    "system-document-content-action-rules/set-enabled",
    async ({ dto, enabled }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            putWithAuth({
                url: `api/sys/document-content-action-rules?enabled=${enabled}`,
                payload: dto,
            })
        )
        const { payload } = result

        if (putWithAuth.fulfilled.match(result)) {
            return
        }

        return rejectWithValue(payload ?? { kind: "unknown" })
    }
)